import React, { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';
import './styles.css';
import icon from './info.svg';


class Tooltip extends Component {
	render() {
		const { description } = this.props;
		return (
			<div className="tooltip">
				{ this.props.icon
					? <img src={icon} width={20} alt=""/>
					: 'i'
				}
				<span className="tooltiptext">
					<FormattedHTMLMessage id={description} />
				</span>
			</div>
		);
	}
}

Tooltip.propTypes = {
	description: PropTypes.string
};

export default Tooltip;
